import React from 'react';
import MyProfile from './MAincon/MyProfile';
import ManageCategory from './MAincon/ManageCategory';
import ImageCreateForm from './MAincon/imagesdash/ImageCreateForm';
import Settings from '../../settings/index';
import AllContactData from '../../core/Contact/AllCOntactData';
import CreateManagement from './GallaryManagement';


const MainContent = ({ activeTab }) => {
  return (
    <div className="w-[80%] p-5 h-screen overflow-y-auto border">
      {activeTab === 'profile' && <div ><MyProfile/></div>}
      {activeTab === 'create-category' && <div><ManageCategory/></div>}
      {activeTab === 'create-mehendi-form' && <div><ImageCreateForm/></div>}
      {activeTab === 'all-clients' && <div><AllContactData/></div>}
      {activeTab === 'create-galary' && <div><CreateManagement/></div>}
      {activeTab === 'settings' && <div><Settings/></div>}
      {activeTab === 'logout' && <div>Logout Content</div>}
    </div>
  );
};

export default MainContent;
